import { getRequestHeader } from "h3";
import { resolveSiteLang } from "@/shared/utils/browserLang";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    const event = useRequestEvent();
    const acceptLang = event ? getRequestHeader(event, "accept-language") ?? "" : "";
    const lang = resolveSiteLang(acceptLang);
    // 302 (temporário), NÃO 301: o destino depende do Accept-Language do usuário.
    // Um 301 seria cacheado pelo navegador/CDN de forma permanente e passaria a
    // ignorar o idioma real (o primeiro que acessasse "fixaria" o redirect).
    // A query vai junto: `/?partner=123` não pode perder o código do afiliado.
    return navigateTo({ path: `/${lang}`, query: to.query }, { redirectCode: 302 });
  }

  if (import.meta.client) {
    // navigator.languages já vem ordenado por prioridade; join com "," reaproveita
    // a mesma regra do SSR (sem q=, a ordem define a prioridade).
    const acceptLang = navigator.languages?.join(",") || navigator.language;
    const lang = resolveSiteLang(acceptLang);
    return navigateTo({ path: `/${lang}`, query: to.query });
  }
});
